export default __webpack_public_path__ + "50f04ff57fdfe230f41232e8e5be6e7d.mp3";